const prefix = {
  FeliCity: 'FeliCity.SuPeRBE.Areas.Users.Models.Dto',
  Microsoft: 'Microsoft.AspNetCore.Identity',
  IdentityServer4: 'IdentityServer4.Models'
};

export default prefix;
